import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Annotation } from '../shared/annotation';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class AnnotationInterceptor implements HttpInterceptor {
  data : any;
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!request.body || !request.body.element || !(request.method === 'PUT' && request.url.startsWith('../rl/ann/annotations'))){
      return next.handle(request);
    }

    this.data = {
      element : request.body.element,
      img : request.body.img
    }
    delete request.body.element;
    delete request.body.img;
  
    return next.handle(request).pipe(
      filter(e => e instanceof HttpResponse && this.data),
      map((e : HttpResponse<any>) => {
        let res = e.clone({body : Object.assign(e.body, this.data)});
        delete this.data;
        return res;
      }));
  }
}
